interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
  articlePublishedTime?: string;
  articleModifiedTime?: string;
  schema?: Record<string, unknown>[];
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  ogImage,
  articlePublishedTime,
  articleModifiedTime,
  schema = [],
}: SEOHeadProps) {
  const fullTitle = title.includes('黑料网') ? title : `${title} - 黑料网`;
  const fullUrl = `https://www.heiliaowang.com${canonicalUrl}`;
  const imageUrl = ogImage || 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20celebrity%20gossip%20news%20platform%20branding%20image%20with%20warm%20red%20accents%2C%20modern%20media%20website%20hero%2C%20Chinese%20entertainment%20news%20aesthetic%2C%20bold%20typography%20feel&width=1200&height=630&seq=og-default&orientation=landscape';

  const allSchemas = [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '黑料网',
      url: 'https://www.heiliaowang.com',
      logo: 'https://www.heiliaowang.com/logo.png',
      description: '专注于娱乐圈、网红明星黑料爆料的内容聚合平台',
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '400-888-6666',
        email: 'tips@heiliaowang.com',
        contactType: 'customer service',
      },
      sameAs: [
        'https://weibo.com/heiliaowang',
        'https://www.douyin.com/user/heiliaowang',
      ],
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '黑料网',
      url: 'https://www.heiliaowang.com',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://www.heiliaowang.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: fullTitle,
      description: description,
      url: fullUrl,
    },
    ...schema,
  ];

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:site_name" content="黑料网" />
      <meta property="og:locale" content="zh_CN" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />

      {/* Article specific */}
      {articlePublishedTime && (
        <meta property="article:published_time" content={articlePublishedTime} />
      )}
      {articleModifiedTime && (
        <meta property="article:modified_time" content={articleModifiedTime} />
      )}

      {/* Schema.org JSON-LD */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(allSchemas) }}
      />
    </>
  );
}